import { cn } from "@/lib/utils";
import { processImageUrl, SmartImage } from "../ui/smart-image";
import { ScrollContainer } from "./scroll-container";

function CryptoTimeSelect(
    { list, onClick, active, className, isCrypto = false }: {
        list: any[];
        onClick: ( e: React.MouseEvent<HTMLElement>, tp: any ) => void;
        active: any;
        className?: string;
        isCrypto?: boolean;
    },
) {
    return (
        <div className={`-mx-4 px-4 overflow-hidden ${className}`}>
            <ScrollContainer gradientColor="var(--ui-surface-page)">
                {list.map( ( item ) => (
                    <button
                        key={item.id}
                        onClick={( e ) => onClick( e, item )}
                        className={cn(
                            "flex-shrink-0 size-[60px] text-xs font-medium rounded-[8px] cursor-pointer transition-all flex items-center flex-col justify-center",
                            active === item ? "text-t1 bg-surface-card rounded-[8px]" : "text-t3",
                            isCrypto ? "gap-2" : "gap-1",
                        )}
                    >
                        {isCrypto
                            ? (
                                <span
                                    className="size-4 flex-shrink-0 bg-current"
                                    style={{
                                        mask: `url("${
                                            processImageUrl( item.pictureUrl, { noResize: true } )
                                        }") no-repeat center / contain`,
                                        WebkitMask: `url("${
                                            processImageUrl( item.pictureUrl, { noResize: true } )
                                        }") no-repeat center / contain`,
                                    }}
                                />
                            )
                            : <SmartImage src={item.pictureUrl} className="size-5 flex-shrink-0" alt={""} />}
                        <div className="capitalize">{item.name}</div>
                    </button>
                ) )}
            </ScrollContainer>
        </div>
    );
}

export default CryptoTimeSelect;
